import React, { useState } from 'react'
import moment from 'moment'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import callAPI from '../../../helpers/callAPI'
import { Modal } from 'react-bootstrap'

export default function RequestVacationModal({ adminId, setShowModal, refetch, showSystemMessage }) {
    const [data, setData] = useState({
        adminId: adminId,
        startDate: moment().format('YYYY-MM-DD'),
        days: '',
        notes: ''
    })
    const [dataLoaded, setDataLoaded] = useState(true)
    const [showInternalPopup, setShowInternalPopup] = useState(false)

    const handleInitialSubmit = async (e) => {        
        e.preventDefault()

        setDataLoaded(false)

        const result = await callAPI('admin/vacation', 'POST', data)

        if (result.success) {
            showSystemMessage('success', 'Vacation request submitted.')
        } else {
            showSystemMessage('error', result.errors.message)
        }

        setDataLoaded(true)

        setShowInternalPopup(true)
    }

    const handleCloseWarning = () => {
        setShowInternalPopup(false)
        setShowModal(false)
        refetch()
    }

    return (
        <>
            <div className="card">
                <div className="card-header">Request Vacation</div>
                <div className="card-body">
                    <form onSubmit={handleInitialSubmit}>
                        <div className="form-group d-flex align-items-center">
                            <label style={{ width: '150px' }}>Start Date:</label>
                            <input
                                type="date"
                                min={moment().format('YYYY-MM-DD')}
                                required
                                className="form-control ml-2"
                                defaultValue={data.startDate}
                                onChange={(e) => setData({ ...data, startDate: e.target.value })}
                            />
                        </div>

                        <div className="form-group d-flex align-items-center">
                            <label style={{ width: '150px' }}>Number of <u>BUSINESS</u> days:</label>
                            <input
                                type="number"
                                step=".5"
                                required
                                className="form-control ml-2"
                                defaultValue={data.days}
                                onChange={(e) => setData({ ...data, days: parseFloat(e.target.value) })}
                            />
                        </div>

                        <div className="form-group d-flex align-items-center">
                            <label style={{ width: '150px' }}>Notes:</label>
                            <input
                                type="text"
                                className="form-control ml-2"
                                defaultValue={data.notes}
                                onChange={(e) => setData({ ...data, notes: e.target.value })}
                            />
                        </div>

                        <div className="text-right mt-2">
                            <button className="btn btn-link text-danger" onClick={(e) => {
                                e.preventDefault()
                                setShowModal(false)
                            }}>
                                Cancel
                            </button>
                            <button className="btn btn-primary ml-2" type="submit" disabled={!dataLoaded}>
                                {dataLoaded ? 'Submit Request' : <><FontAwesomeIcon icon="spinner" spin /> Submitting...</>}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
            
            <Modal show={showInternalPopup} size="md" onHide={() => handleCloseWarning()}>
                <div className="modal d-block" tabIndex="-1" role="dialog" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
                    <div className="modal-dialog modal-dialog-centered" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Attention</h5>
                                <button type="button" className="close" onClick={() => handleCloseWarning()}>
                                    <span>&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <p>Please remember to submit your vacation request in <a href="https://mrge-group-gmbh.app.personio.com/" target="_blank" rel="noopener noreferrer">Personio</a>.</p>
                            </div>
                            <div className="modal-footer">
                                <button className="btn btn-primary" onClick={()=>handleCloseWarning()}>OK</button>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>
        </>
    )
}
